module.exports = __webpack_public_path__ + "img/liverpool.6ed8119d.png";